const FarmerSpaceInternModule = {
  namespaced: true,
  state: {
    data: [],
    dialog: false,
    idx: ""
  },
  mutations: {
    UPDATE_DIALOG: (state, payload) => {
      state.dialog = payload;
    },
    SET_IDX: (state, payload) => {
      state.idx = payload;
    },
    FETCH: (state, payload) => {
      state.data = payload;
    },
    DELETE: (state, payload) => {
      let index = state.data.findIndex(data => data.idx === payload);
      state.data.splice(index, 1);
    },
    INSERT: (state, payload) => {
      let index = state.data.findIndex(data => data.idx === payload.idx);
      state.data[index] = payload;
    }
  },
  actions: {
    async fetch({ commit }) {
      try {
        const response = await axios.get(`/farmerspace/intern`);
        commit("FETCH", response.data);
      } catch (error) {
        throw new Error(error);
      }
    },
    async delete({ commit }, payload) {
      try {
        const response = await axios.delete(`/farmerspace/intern/${payload}`);
        if (response.data.message === true) {
          iziToast.info({
            title: "Deleted!",
            position: "bottomRight"
          });
        }
        commit("DELETE", payload);
      } catch (error) {
        throw new Error(error);
      }
    },
    async insert({ commit, dispatch }, payload) {
      try {
        const response = await axios.post(`/farmerspace/intern`, payload);
        // console.log(response.data);
        if (response.data.message === true) {
          iziToast.success({
            title: "Created!",
            position: "bottomRight"
          });
          dispatch("fetch");
          commit("INSERT", payload);
          return response.data.documentId;
        }
      } catch (error) {
        throw new Error(error);
      }
    },
    async updatePicture({ commit, dispatch }, payload) {
      try {
        const response = await axios.put(
          `/farmerspace/intern/picture`,
          payload
        );
        if (response.data.message === true) {
          dispatch("fetch");
          commit("INSERT", payload);
          const notification = {
            type: "success",
            message: "Update Picture!"
          };
          dispatch("Notification/add", notification, { root: true });
        }
      } catch (error) {
        throw new Error(error);
      }
    }
  },
  getters: {
    getAll: state => {
      return state.data;
    }
  }
};

export default FarmerSpaceInternModule;



// WEBPACK FOOTER //
// ./src/store/modules/farmerspace/internship.js